import { Button } from "components/DesignSystem/Button/Button";
import { useCopyToClipboard } from "hooks/useCopyToClipboard";

type CopyableTextProps = {
  value: string;
};

export const CopyableText = ({ value }: CopyableTextProps) => {
  const { copyToClipboard } = useCopyToClipboard();

  return (
    <Button
      type="button"
      customType="link"
      className="!t-inline !t-align-baseline !t-text-body-sm"
      onClick={() => copyToClipboard(value)}
    >
      {value}
    </Button>
  );
};
